import { LinkField, Text, TextField } from '@sitecore-jss/sitecore-jss-nextjs';
import ScLink from 'components/Generic/SitecoreWrappers/ScLink';
import { ComponentProps } from 'lib/component-props';
import useHelpers from 'src/hooks/helpers';
import classnames from 'classnames';
import { useSitecoreContext } from 'hooks/useSitecoreContext';

type LinkItem = {
  displayName: string;
  fields: {
    link: LinkField & {
      editable: string;
      editableFirstPart: string;
      editableLastPart: string;
    };
    description?: TextField;
  };
};

type Fields = {
  title?: TextField;
  link?: LinkField;
  items?: Array<LinkItem>;
};

type DocumentListingProps = ComponentProps & {
  fields: Fields;
  hideTitle: boolean;
  className?: string;
};

const DocumentListings = ({
  fields,
  rendering,
  hideTitle = false,
  className,
}: DocumentListingProps): JSX.Element => {
  const { sitecoreContext } = useSitecoreContext();
  const isExperienceEditor = sitecoreContext.pageEditing;
  const { anchorId } = useHelpers(rendering);

  const titleExist = !!fields?.title?.value && !hideTitle;

  const haveLinks = !!fields?.items?.length;

  const ctaLinkExist = !!fields?.link?.value?.text && !!fields?.link?.value?.href;

  const isExternalLink = (linkType?: string) => {
    return linkType === 'external';
  };
  const setLinkTarget = (item: LinkItem) => {
    const link = {
      ...item.fields.link,
      value: {
        ...item.fields.link.value,
        target: '_blank',
        text: item.fields.link.value.text
          ? item.fields.link.value.text
          : item.fields.link.value.href,
      },
    };

    const experienceEditorLinkProps = {
      editable: link.editable?.replace('No text in field', item.displayName),
      editableFirstPart: link.editableFirstPart?.replace('No text in field', item.displayName),
      editableLastPart: link.editableLastPart?.replace('No text in field', item.displayName),
    };

    return isExperienceEditor ? { ...link, ...experienceEditorLinkProps } : link;
  };
  const linkHaveValue = (item: LinkItem) => {
    return !!item.fields.link?.value?.href;
  };
  const handleDocumentCLick = () => {
    // eventBus.emit('click-event', event);
  };
  return (
    <section
      id={anchorId}
      ata-e2e-component-uid={rendering?.uid}
      className={classnames(
        'document-listing container background-white default-section-padding link-change',
        className
      )}
    >
      {(isExperienceEditor || titleExist) && (
        <div className="col-12 col-md-8">
          <Text tag="h2" field={fields.title} className="background-to-change" />
        </div>
      )}

      {haveLinks && (
        <div className="mt-2">
          {fields.items?.map((item, index) => {
            if (linkHaveValue(item) || isExperienceEditor) {
              return (
                <div
                  key={index}
                  className="faded-underline col-12 py-3"
                  onClick={handleDocumentCLick}
                >
                  <ScLink field={setLinkTarget(item)} className="text-link me-1" showExternalIcon />
                  {!isExternalLink(item.fields.link.value.linktype) && (
                    <em className="bi-download" aria-hidden="true" />
                  )}
                  <Text
                    tag="p"
                    field={item.fields.description}
                    className="background-to-change footnote text-grey mt-1"
                  />
                </div>
              );
            } else {
              return null;
            }
          })}
        </div>
      )}
      {ctaLinkExist && fields.link && (
        <div className="link col-12 d-flex align-items-center" style={{ paddingTop: 40 }}>
          <ScLink className="me-3" field={fields.link} />
          <em className="bi-chevron-right d-flex align-items-center" aria-hidden="true" />
        </div>
      )}
    </section>
  );
};

export default DocumentListings;
